import React, {FC} from 'react';
import cn from 'classnames';
import styles from './TitledText.css';

type TitledTextProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>;

export const TitledText: FC<TitledTextProps> = ({children, className, ...props}) => {
	return (
		<span className={cn(styles.root, className)} {...props}>
			{children}
		</span>
	);
};

TitledText.displayName = 'TitledText';
